export const colors = {
    blue: {
        primary: '#327AF9',
        300: '#ADCAFD',
        500: '#327AF9',
        600: '#2D6EE0',
        700: '#1E4995',
    },
    green: {
        primary: '#17a55a',
        300: '#9FEDD6',
        500: '#20BF6B',
        600: '#0EBD89',
        700: '#0A7E5B',
    },
    red: {
        primary: '#ED6471',
        300: '#F8C1C6',
        500: '#ED6471',
        600: '#D55A66',
        700: '#8E3C44',
    },
    yellow: {
        primary: '#F7B731',
        300: '#FCE2AD',
        500: '#F7B731',
        600: '#DEA52C',
        700: '#946E1D',
    },
    purple: {
        primary: '#8854D0',
        500: '#8854D0',
    },
    lightBlue: {
        primary: '#54ABEE',
        500: '#54ABEE',
    },
    text: {
        primary: '#435565',
        50: '#F6F7F7',
        500: '#435565',
        900: '#141A1E',
    },
    gray: {
        primary: '#C4CDD5',
        50: '#FCFDFD',
        300: '#E7EBEE',
        500: '#C4CDD5',
        800: '#585C60',
        900: '#3B3E40',
    },
    white: {
        primary: '#F6F9FC',
        50: '#FFFFFF',
        500: '#F6F9FC',
        800: '#6F7071',
        900: '#4A4B4C',
    },
};

export default colors;
